import Vue from 'vue'
const optimizely = require('@optimizely/optimizely-sdk');

const optimizelyClientInstance = optimizely.createInstance({
  sdkKey: process.env.VUE_APP_OPTMINIZELY_KEY,
  datafileOptions: {
    updateInterval: 60000,
    autoUpdate: true,
    urlTemplate: "https://cdn.optimizely.com/datafiles/25uXi6WTQAcaV1asbaitu.json",
  },
});

optimizelyClientInstance.onReady().then(() => {

});

Vue.prototype.$optimizely = optimizelyClientInstance;
